export const environment = {
  production: false,
  envName: 'DEV',
  apiBaseUrl: '/api/extid-urs/v1',
  key_value: '0x4AAAAAAB9umz4WwXNaXpKh',
  enableCloudflare: false,
  portalLoginUrl: 'https://ibo--qa.sandbox.my.site.com/ibportal/IBPortalLogin',
  contactUsUrl: 'https://help.ibo.org/s/open-case/'
};
